export const PLAN_CURRENCIES = [
  { value: 'EGP', label: 'جنيه مصري (EGP)', symbol: 'ج.م' },
  { value: 'USD', label: 'دولار (USD)', symbol: '$' },
  { value: 'SYP', label: 'ليرة سورية (SYP)', symbol: 'ل.س' },
  { value: 'SAR', label: 'ريال سعودي (SAR)', symbol: 'ر.س' },
  { value: 'AED', label: 'درهم إماراتي (AED)', symbol: 'د.إ' },
  { value: 'JOD', label: 'دينار أردني (JOD)', symbol: 'د.أ' },
  { value: 'KWD', label: 'دينار كويتي (KWD)', symbol: 'د.ك' },
  { value: 'ILS', label: 'شيكل (ILS)', symbol: '₪' },
  { value: 'TRY', label: 'ليرة تركية (TRY)', symbol: '₺' },
  { value: 'EUR', label: 'يورو (EUR)', symbol: '€' },
] as const;

const SYMBOLS: Record<string, string> = Object.fromEntries(
  PLAN_CURRENCIES.map((c) => [c.value, c.symbol]),
);
const LABELS: Record<string, string> = Object.fromEntries(
  PLAN_CURRENCIES.map((c) => [c.value, c.label]),
);

export const PlanCurrency = {
  SUPPORTED: PLAN_CURRENCIES.map((c) => c.value) as string[],
  symbol(code: string): string {
    return SYMBOLS[code] ?? 'ج.م';
  },
  label(code: string): string {
    return LABELS[code] ?? 'جنيه مصري (EGP)';
  },
};
